export var initialState = {
    goalsRowsData: [],
    deleteRowsData: [],
    isAddingGoal: false,
    goalsFilter: 'all',
};
